import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 24,
    seconds: 23
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-8 md:py-20 px-4" data-id="element-15">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-2xl mx-auto bg-slate-900 rounded-[2.5rem] p-8 md:p-12 text-center shadow-2xl border border-white/5" data-id="element-16">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-17">
          <span className="text-2xl md:text-3xl" data-id="element-18">⏰</span>
          <h2 className="text-xl md:text-3xl font-black text-white uppercase tracking-tight leading-tight" data-id="element-19">
            EL PRECIO DE <br className="md:hidden" data-id="element-20" /> LANZAMIENTO TERMINA EN:
          </h2>
        </div>

        <div className="flex justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-21">
          <div className="flex flex-col" data-id="element-22">
            <span className="text-5xl md:text-7xl font-black text-rose-500 tabular-nums" data-id="element-23">
              {formatNumber(timeLeft.hours)}
            </span>
            <span className="text-[10px] md:text-xs font-bold text-slate-500 uppercase mt-1" data-id="element-24">
              HS
            </span>
          </div>
          <span className="text-4xl md:text-6xl font-black text-white/20 mb-6" data-id="element-25">
            :
          </span>
          <div className="flex flex-col" data-id="element-26">
            <span className="text-5xl md:text-7xl font-black text-rose-500 tabular-nums" data-id="element-27">
              {formatNumber(timeLeft.minutes)}
            </span>
            <span className="text-[10px] md:text-xs font-bold text-slate-500 uppercase mt-1" data-id="element-28">
              MIN
            </span>
          </div>
          <span className="text-4xl md:text-6xl font-black text-white/20 mb-6" data-id="element-29">
            :
          </span>
          <div className="flex flex-col" data-id="element-30">
            <span className="text-5xl md:text-7xl font-black text-rose-500 tabular-nums" data-id="element-31">
              {formatNumber(timeLeft.seconds)}
            </span>
            <span className="text-[10px] md:text-xs font-bold text-slate-500 uppercase mt-1" data-id="element-32">
              SEG
            </span>
          </div>
        </div>

        <p className="text-lg md:text-xl font-bold text-white mb-10" data-id="element-33">
          Después sube <span className="text-rose-500" data-id="element-34">$10.000 ARS</span> y no
          vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto" data-id="element-35">
          <div className="flex justify-between items-end mb-3" data-id="element-36">
            <div className="flex items-center gap-2" data-id="element-37">
              <div className="w-2 h-2 bg-rose-500 rounded-full animate-pulse" data-id="element-38" />
              <span className="text-[10px] md:text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-39">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-[10px] md:text-xs font-black text-white uppercase" data-id="element-40">
              Quedan pocos
            </span>
          </div>

          <div className="h-3 bg-white/10 rounded-full overflow-hidden mb-2" data-id="element-41">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gradient-to-r from-rose-600 to-orange-500 rounded-full" data-id="element-42" />
          </div>
          <p className="text-[10px] font-bold text-slate-500 uppercase tracking-widest" data-id="element-43">
            68% de los cupos tomados
          </p>
        </div>
      </motion.div>
    </section>;
}